export const txrc = {
  agencyCode: '600',
  name: 'Texas Racing Commision',
  shortName: 'TXRC',
  slug: 'TXRC',
};
